import { useMediaQuery } from "react-responsive"

const useWindowsSize = () => {
  const largeScreen = useMediaQuery({ query: "(max-width: 991px)" })
  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 767px)" })
  const isMobile = useMediaQuery({ query: "(max-width: 575px)" })
  return { isMobileOrTablet, isMobile, largeScreen }
}

export default useWindowsSize
